export const API_HOSTNAME_DOCUMENT_REQUEST = 'https://qa-core.firmaya.co/documentmanager/api/DocumentManager';

export const API_HOSTNAME_QR_REQUEST = 'https://qa-core.firmaya.co/qrmanager/api/QR/consultardocumento';
//export const API_HOSTNAME_DOCUMENT_REQUEST = 'http://qa.firmadigital.co/doc/documentmanager/api/DocumentManager';

//export const API_HOSTNAME_QR_REQUEST = 'https://ym9x2ku6x4.execute-api.us-east-2.amazonaws.com/dev/qrmanager/api/QR/consultardocumento';
//export const API_HOSTNAME_DOCUMENT_REQUEST = 'https://ym9x2ku6x4.execute-api.us-east-2.amazonaws.com/dev/documentmanager/api/DocumentManager';




//export const API_HOSTNAME_QR_REQUEST = 'https://qa-core.firmaya.co/qr/qrmanager/api/QR/consultardocumento';
//export const API_HOSTNAME_DOCUMENT_REQUEST = 'https://qa-core.firmaya.co/doc/documentmanager/api/DocumentManager';

